import { Check } from "lucide-react";
import { toast } from "sonner";
import type { HabitStatus } from "@/hooks/use-habits";
import { tapHabit } from "@/lib/habits";
import { cn } from "@/lib/utils";

/**
 * The one-tap check-off (HB-1): a round button that fills as check-ins reach
 * the target. For target-1 habits it toggles; otherwise it counts up and resets.
 */
export function HabitCheck({ status, day }: { status: HabitStatus; day: string }) {
	const { habit, streak } = status;
	const target = habit.target_per_period;
	const label = `${streak.periodMet ? "Done" : "Check off"}: ${habit.name} (${streak.periodCount}/${target}${
		habit.cadence === "weekly" ? " this week" : ""
	})`;

	async function tap() {
		try {
			await tapHabit(habit, day);
		} catch {
			toast.error("Could not save on this device. Try again.");
		}
	}

	return (
		<button
			type="button"
			onClick={tap}
			aria-label={label}
			aria-pressed={streak.periodMet}
			className={cn(
				"flex size-11 shrink-0 items-center justify-center rounded-full border-2 text-xs font-semibold tabular-nums transition-colors",
				streak.periodMet
					? "border-primary bg-primary text-primary-foreground"
					: "border-muted-foreground/40 hover:border-primary",
			)}
		>
			{streak.periodMet ? (
				<Check className="size-5" />
			) : target > 1 ? (
				`${streak.periodCount}/${target}`
			) : null}
		</button>
	);
}
